import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { applicationHistory } from '../../common/application-history';
import UrlMappings from '../../common/url-mappings';

import {
	enableAlbumSelectionMode,
	disableAlbumSelectionMode,
	enableAlbumItemSelectionMode,
	disableAlbumItemSelectionMode
} from '../../settings/actions/application-actions';

import {
	enableDiscItemSelectionMode,
	disableDiscItemSelectionMode,
	clearSelectedDiscItems,
	enableDiscItemArrangeMode,
	disableDiscItemArrangeMode
} from "../../disc/actions/disc-actions";

import { clearSelectedAlbumItems, clearAlbumItems } from '../../album-view/actions/album-item-actions';
import { favoriteSelectedItems,setAlbumArrangeMode } from '../../album-view/actions/album-actions';
import { showAddPaymentAccountDialog } from '../../account/actions/payment-accounts-actions';

import '../style/header.scss';

//TODO: Make these async components
//Headers
import DefaultHeader from './default-header';
import AlbumItemViewHeader from './album-item-view-header';
import AlbumItemSelectModeHeader from './album-item-select-mode-header';
import AssetArrangeModeHeader from './album-item-arrange-mode-header';
import AlbumViewHeader from './album-view-header';
import AlbumArrangeModeHeader from './album-arrange-mode-header';

import AlbumSelectModeHeader from './album-select-mode-header';
import DiscViewHeader from './disc-view-header';
import DiscItemViewHeader from './disc-item-view-header';
import DiscItemSelectModeHeader from './disc-item-select-mode-header';
import DiscItemArrangeModeHeader from './disc-item-arrange-mode-header';
import DiscWizardHeader from './disc-wizard-header';
import PaymentAccountsHeader from './payment-accounts-header';

import ErrorHeader from './error-header';
import CartHeader from "./cart-header";

class MultiViewHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dirtyRoute: true
		};
	}

	componentDidMount() {
		applicationHistory.listen(location => {
			this.setState({ dirtyRoute: true });
			this.handleSelectionMode(location);
		});
		this.handleSelectionMode(applicationHistory.location);
	}

	shouldComponentUpdate() {
		return this.state.dirtyRoute;
	}

	componentWillUnmount() {}

	handleSelectionMode(location) {
		const pathname = location.pathname;
		if (pathname === '/my/albums') {
			this.props.disableAlbumItemSelectionMode();
            this.props.setAlbumArrangeMode(false);
		} else if (pathname === '/my/albums/select') {
			this.props.enableAlbumSelectionMode();
		} else if (pathname === '/my/albums/arrange') {
            this.props.setAlbumArrangeMode(true);
        } else if (pathname.indexOf('/album/') > -1 && pathname.indexOf('/select') > -1) {
			this.props.enableAlbumItemSelectionMode();
		} else if (pathname.indexOf('/album/') > -1) {
			this.props.disableAlbumItemSelectionMode();
		}
        if (pathname === '/my/discs') {
            this.props.disableDiscItemSelectionMode();
        } else if (pathname === '/my/discs/select') {
            //this.props.enableAlbumSelectionMode();//TODO: this does not exist yet
        } else if (pathname.indexOf('/disc/') > -1 && pathname.indexOf('/select') > -1) {
            this.props.enableDiscItemSelectionMode();
        } else if (pathname.indexOf('/disc/') > -1 && pathname.indexOf('/arrange') > -1) {
            this.props.enableDiscItemArrangeMode();
        } else if (pathname.indexOf('/disc/') > -1) {
            this.props.disableDiscItemSelectionMode();
            this.props.disableDiscItemArrangeMode();

        }
    }

	render() {
		return (
			<div className="header-container">{getHeaderFromPathname(applicationHistory.location.pathname, this.props)}</div>
		);
	}
}

const navigateHome = () => {
	applicationHistory.push(UrlMappings.HOME);
};

const getHeaderFromPathname = (pathname, props) => {
	if (pathname === '/my/albums') {
		return <AlbumViewHeader {...props} navigateHome={navigateHome} />;
	} else if (pathname === '/my/albums/select') {
		return <AlbumSelectModeHeader {...props} navigateHome={navigateHome} />;
	} else if (pathname === '/my/albums/arrange') {
        return <AlbumArrangeModeHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/album/') > -1 && pathname.indexOf('/select') > -1) {
		return <AlbumItemSelectModeHeader {...props} navigateHome={navigateHome} />;
	} else if (pathname.indexOf('/my/album/') > -1 && pathname.indexOf('/arrange') > -1) {
		return <AssetArrangeModeHeader {...props} navigateHome={navigateHome} />;

	} else if (pathname.indexOf('/my/album/') > -1) {
		return <AlbumItemViewHeader {...props} navigateHome={navigateHome} />;
	} else if (pathname.indexOf('/my/upload') > -1) {
        return <DefaultHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/downloads') > -1) {
        return <DefaultHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/app-download') > -1) {
		return <DefaultHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/cart/digitization/1') > -1) {
		return <CartHeader {...props} navigateHome={navigateHome} title="Step 1: Review Your Order" />
	} else if (pathname.indexOf('/my/cart/digitization/2') > -1) {
		return <CartHeader {...props} navigateHome={navigateHome} title="Step 2: iMemories Cloud" />
	} else if (pathname.indexOf('/my/cart/digitization/3') > -1) {
		return <CartHeader {...props} navigateHome={navigateHome} title="Step 3: Enhance Your Memories" />
	} else if (pathname.indexOf('/my/cart/digitization') > -1) {
		return <CartHeader {...props} navigateHome={navigateHome} title="Step 1: Review Your Order" />
	} else if (pathname.indexOf('/my/cart/checkout') > -1) {
        return <CartHeader {...props} navigateHome={navigateHome} title="Checkout" />
    } else if (pathname.indexOf('/my/cart/receipt') > -1) {
        return <CartHeader {...props} navigateHome={navigateHome} title="Order Completed" />
	} else if (pathname.indexOf('/my/cart/history') > -1) {
        return <DefaultHeader {...props} navigateHome={navigateHome} />;
	} else if (pathname.indexOf('/my/cart') > -1) {
        return <CartHeader {...props} navigateHome={navigateHome} title="Cart" />
    } else if (pathname.indexOf('/my/account') > -1) {
        return <DefaultHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/view/') === 0) {
        return null;
    } else if (pathname.indexOf('/my/disc/') > -1 && pathname.indexOf('/select') > -1) {
		return <DiscItemSelectModeHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/disc/') > -1 && pathname.indexOf('/arrange') > -1) {
        return <DiscItemArrangeModeHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf('/my/disc-wizard') > -1 ) {
        return <DiscWizardHeader {...props} navigateHome={navigateHome} />;
    } else if (pathname.indexOf("/my/disc/") > -1){
		return <DiscItemViewHeader {...props} navigateHome={navigateHome}/>
	} else if (pathname.indexOf('/my/discs') === 0) {
        return <DiscViewHeader {...props} navigateHome={navigateHome}/>;
	} else if (pathname.indexOf('/my/payments') > -1) {
		return <PaymentAccountsHeader {...props} navigateHome={navigateHome}/>;
	} else if (pathname.indexOf('/my/shop') > -1) {
		return <DefaultHeader {...props} navigateHome={navigateHome} />;
	}else if (
		pathname.indexOf('/error') > -1 ||
		pathname.indexOf('signup') > -1 ||
		pathname.indexOf('forgot') > -1
	) {
		return <ErrorHeader {...props} navigateHome={navigateHome} />;
	}
	return <DefaultHeader {...props} />;
};

const mapStateToProps = (state, ownProps) => {
	return {
		//TODO: LKG: Need a smarter solution here, probably in a reducer
		location: ownProps.location,
		applicationSelectionMode: state.applicationState.selectEnabled,
		selectedAlbumItems: state.albumItems.selectedItems,
		albumItems: state.albumItems,
		parentAlbum: state.parentAlbum
	};
};

const mapDispatchToProps = dispatch => {
	return {
    enableAlbumSelectionMode: () => dispatch(enableAlbumSelectionMode()),
    disableAlbumSelectionMode: () => dispatch(disableAlbumSelectionMode()),
    enableAlbumItemSelectionMode: () => dispatch(enableAlbumItemSelectionMode()),
    disableAlbumItemSelectionMode: () => dispatch(disableAlbumItemSelectionMode()),
    clearAlbumItems: () => dispatch(clearAlbumItems()),
    clearSelectedAlbumItems: () => dispatch(clearSelectedAlbumItems()),
    favoriteSelectedItems: ids => favoriteSelectedItems(dispatch, ids),
    enableDiscItemSelectionMode: () => dispatch(enableDiscItemSelectionMode()),
    disableDiscItemSelectionMode: () => dispatch(disableDiscItemSelectionMode()),
    enableDiscItemArrangeMode: () => dispatch(enableDiscItemArrangeMode()),
    disableDiscItemArrangeMode: () => dispatch(disableDiscItemArrangeMode()),
    clearSelectedDiscItems: () => dispatch(clearSelectedDiscItems()),
    showAddPaymentAccountDialog: () => dispatch(showAddPaymentAccountDialog()),
    setAlbumArrangeMode: (flag) => dispatch(setAlbumArrangeMode(flag))

    };
};

MultiViewHeader.propTypes = {
	enableAlbumSelectionMode: PropTypes.func,
	disableAlbumSelectionMode: PropTypes.func,
	enableAlbumItemSelectionMode: PropTypes.func,
	disableAlbumItemSelectionMode: PropTypes.func,
    enableDiscItemSelectionMode: PropTypes.func,
    disableDiscItemSelectionMode: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiViewHeader);



// WEBPACK FOOTER //
// ./src/header/components/multi-view-header.jsx